// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div:has(> .Upload_input-upload__l9NCA) {
  width: 90%;
}`, "",{"version":3,"sources":["webpack://./src/components/Upload/Upload.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF","sourcesContent":["div:has(> .input-upload) {\n  width: 90%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-upload": `Upload_input-upload__l9NCA`
};
export default ___CSS_LOADER_EXPORT___;
